import React from "react";
import ChangeStatus from "./ChangeStatus";
import AssignToRider from "./AssignToRider";
import Exchange from "./Exchange";
import ReturnRTV from "./ReturnRTV";
import ExtraMile from "./ExtraMile";
import Transit from "./Transit";
import Bulk_Comment from "./Bulk_Comment";

const OrderActionMenu = ({
  actionType,
  handleActionMenu,
  isLoading,
  chargevalue,
}: any) => {
  return (
    <>
      {actionType === "Change Status" ? (
        <ChangeStatus
          handleActionMenu={handleActionMenu}
          isLoading={isLoading}
        />
      ) : actionType === "Assign To Rider" ? (
        <AssignToRider
          handleActionMenu={handleActionMenu}
          isLoading={isLoading}
        />
      ) : actionType === "Exchange" ? (
        <Exchange handleActionMenu={handleActionMenu} isLoading={isLoading} />
      ) : actionType === "RTV/Return" ? (
        <ReturnRTV
          handleActionMenu={handleActionMenu}
          isLoading={isLoading}
          chargevalue={chargevalue}
        />
      ) : actionType === "Bulk Comment" ? (
        <Bulk_Comment
          handleActionMenu={handleActionMenu}
          isLoading={isLoading}
        />
      ) : actionType === "Extra Mile Charge" ? (
        <ExtraMile handleActionMenu={handleActionMenu} isLoading={isLoading} />
      ) : (
        <Transit handleActionMenu={handleActionMenu} isLoading={isLoading} />
      )}
    </>
  );
};

export default OrderActionMenu;
